import React, {useEffect} from 'react';
import {Button, Card, CardTitle, Icon, Table} from "react-materialize";
import styled from "styled-components";
import EditOptions from "../EditOptions.react";

const AuthRole = ({role}) => {
  return (
    <tr>
      <td>
        {role.name}
      </td>
      <td>
        {role.description}
      </td>
      <td>
        {role.id}
      </td>
      <td>
        <EditOptions />
      </td>
    </tr>
  )
}

export default AuthRole;